import { Controller } from '@hotwired/stimulus'
import TomSelect from "tom-select";

export default class extends Controller {
  static values = { options: Object }

  connect() {
    // Remove form-input class to avoid conflicts
    this.element.classList.remove("form-input")

    // Check if this has max-items constraint (simulated single select)
    const maxItems = this.element.dataset.maxItems ? parseInt(this.element.dataset.maxItems) : null;
    const isLimitedSingle = maxItems === 1;

    // Check if this is a remote search select
    const searchUrl = this.element.dataset.searchUrl;
    const gigId = this.element.dataset.gigId;

    // Default options for uniform UI
    const defaultOptions = {
      plugins: {
        remove_button: {
          title: 'Supprimer'
        },
        clear_button: {
          title: 'Effacer'
        }
      },
      maxItems: maxItems || null,
      maxOptions: null, // Display all options (no limit)
      searchField: ['text', 'value'],
      persist: false,
      // Custom rendering for consistent UI with HTML support
      render: {
        item: function(data, escape) {
          // Don't escape HTML for items that contain icons
          if (data.text && data.text.includes('<i class=')) {
            return '<div class="item">' + data.text + '</div>';
          }
          return '<div class="item">' + escape(data.text) + '</div>';
        },
        option: function(data, escape) {
          // Don't escape HTML for options that contain icons
          if (data.text && data.text.includes('<i class=')) {
            return '<div>' + data.text + '</div>';
          }
          return '<div>' + escape(data.text) + '</div>';
        }
      }
    };

    // For limited single selects, force specific behavior
    if (isLimitedSingle) {
      defaultOptions.hideSelected = true;
      defaultOptions.closeAfterSelect = true;
    }

    // Add AJAX search configuration if search URL is provided
    if (searchUrl) {
      defaultOptions.load = (query, callback) => {
        if (!query.length) return callback();

        const url = new URL(searchUrl, window.location.origin);
        url.searchParams.set('q', query);
        if (gigId) url.searchParams.set('gig_id', gigId);

        fetch(url)
          .then(response => response.json())
          .then(json => callback(json))
          .catch(() => callback());
      };
      defaultOptions.valueField = 'id';
      defaultOptions.labelField = 'text';
      defaultOptions.searchField = ['text', 'name', 'city'];
    }

    const options = {
      ...defaultOptions,
      ...this.optionsValue,
      plugins: {
        ...defaultOptions.plugins,
        ...this.optionsValue.plugins
      }
    };
    
    try {
      this.tomselect = new TomSelect(this.element, options);
      
      // Add CSS class for styling consistency
      if (this.tomselect.control) {
        this.tomselect.control.classList.add('ts-control-uniform');
        if (isLimitedSingle) {
          this.tomselect.control.classList.add('ts-single-like-multiple');
        }
      }
      
    } catch (error) {
      console.error('Error initializing TomSelect:', error);
    }
  }

  disconnect() {
    if (this.tomselect) {
      this.tomselect.destroy();
    }
  }
}
